<ng-otp-input
  id="test-2fa-code-input"
  [config]="config"
  (onInputChange)="onOtpChange($event)">
</ng-otp-input>
